// TODO: [SP-10364] re-introduce ACCOUNT and user_id once the server-side
// dual-source policy is settled. Atlas currently derives both from the token.
export const buildHandshakeUrl = (endpoint: string, token: string): string => {
  const url = new URL(endpoint);
  url.searchParams.set("token", token);
  return url.toString();
};
